import React from 'react';

import Spinner from 'Shared/components/Spinner';

type Props = {
  isSubmitting: boolean;
  onSubmit: (event: React.MouseEvent<HTMLInputElement>) => void;
  disabled: boolean;
};

const spinnerStyles = { width: '1rem', height: '1rem', borderWidth: '.15rem', marginLeft: '0.5rem' };

function SignUpButton({ isSubmitting, onSubmit, disabled }: Props) {
  return (
    <button className="btn btn-primary btn-lg w-100 mt-5" type="button" onClick={onSubmit} disabled={disabled}>
      {isSubmitting ? <Spinner activeIf color="#fff" spinnerStyles={spinnerStyles} /> : 'Finish Sign Up'}
    </button>
  );
}

export default SignUpButton;
